module.exports = new __parcel__URL__("board-preview.caf8f30f.svg").toString();